import { CraftJsonDto } from '@builder4/shared/dto/craft';
import type { RootState } from '@/store/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectSectionList = createSelector(
  (state: RootState) => state.sections.sectionList,
  (sectionList) => {
    return sectionList.map((section) => {
      return {
        ...section,
        craftJson: CraftJsonDto.fromSection(section.craftJson),
      };
    });
  },
);
export const selectIsOpenSaveSection = (state: RootState) => state.sections.isOpenSaveSection;
export const selectCreateSectionLoading = (state: RootState) => state.sections.createSectionLoading;
export const selectReadSectionLoading = (state: RootState) => state.sections.readSectionLoading;
export const selectDefaultActiveCategoryId = (state: RootState) =>
  state.sections.defaultActiveCategoryId;
